import { Combobox } from '@headlessui/react';

import { styled } from '@lichtblick/styled';
import { BorderRadius, Colors, Spacing } from '@lichtblick/theme';

export const Container = styled.div`
  position: relative;
  width: 100%;
`;

export const CustomCombobox = styled(Combobox)<{ $hasError?: boolean }>`
  ${({ $hasError }) =>
    $hasError
      ? ` 
      > div {
        border-color: ${Colors.red[100]}; 
      }
 `
      : ''}
`;

export const AutocompleteTrigger = styled.div<{ $isSmall: boolean }>`
  align-items: center;
  background: ${Colors.white};
  border: 1px solid ${Colors.blue[20]};
  border-radius: ${BorderRadius.Xs};
  box-sizing: border-box;
  display: flex;
  flex-shrink: 0;
  gap: var(--spacing-xxs);
  height: 3rem;
  justify-content: space-between;
  min-width: 8rem;
  padding: var(--spacing-xxs);
  padding-left: var(--spacing-xs);
  width: 100%;

  ${({ $isSmall }) =>
    $isSmall &&
    `
    height: 2rem;
    font-size: 0.875rem;
    min-width: 7rem;
  `}
`;

export const AutocompleteButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
`;

export const AutocompleteInput = styled.input`
  border: none;
  font-size: 1rem;
  width: 100%;
  &:focus {
    outline: none;
  }
`;

export const AutocompleteOptions = styled.ul`
  border: 1px solid ${Colors.blue[20]};
  border-radius: ${BorderRadius.Xs};
  display: flex;
  flex-direction: column;
  margin: 0;
  min-width: 8rem;
  padding: 0;
  position: absolute;
  width: 100%;
  z-index: 1000;
`;

export const AutocompleteOption = styled.li`
  align-items: center;
  background: ${Colors.white};
  border-radius: ${BorderRadius.Xs};
  cursor: pointer;
  display: flex;
  gap: ${Spacing.Xxs};

  &[data-headlessui-state~='active'],
  &:hover {
    background: ${Colors.blue[20]};
    box-shadow: inset 0 0 0 1px ${Colors.blue[100]};
    outline: none;
  }

  &:focus {
    outline: none;
  }
`;

export const AutocompleteItem = styled.div<{ $isDeleted?: boolean }>`
  align-items: center;
  color: ${({ $isDeleted }) => ($isDeleted ? Colors.gray[50] : Colors.gray[100])};
  display: flex;
  height: auto;
  min-height: 3rem;
  opacity: ${({ $isDeleted }) => ($isDeleted ? 0.6 : 1)};
  padding: ${Spacing.Xxs};
  text-decoration: ${({ $isDeleted }) => ($isDeleted ? 'line-through' : 'none')};
  width: 100%;
`;
export const OptionsContainer = styled.div`
  max-height: 17rem;
  overflow-y: auto;
`;
export const AutocompleteItemTeam = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin: 0.5rem;
  width: 100%;
`;

export const AutocompleteItemInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const AutocompleteItemInfoBottom = styled.div`
  display: flex;
  flex-direction: row;
`;

export const AutocompleteItemInfoName = styled.p`
  color: ${Colors.gray[50]};
  margin: 0;
`;

export const AutocompleteItemInfoText = styled.p`
  color: ${Colors.gray[100]};
  font-size: 0.625rem;
  margin: 0;
`;
